
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hire-flutter-developers",
      function () {
        return require("private-next-pages/hire-flutter-developers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hire-flutter-developers"])
      });
    }
  